export const cover = [
  {
    "title": "",
    "url": "domestic/negligence/2021_05_18 COVERING LETTER WSP-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_05_18 COVERING LETTER WSP-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_05_18 COVERING LETTER WSP-3.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_05_18 COVERING LETTER WSP-4.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_05_18 COVERING LETTER WSP-5.jpg"
  }
];
